import React from 'react';
import PropTypes from 'prop-types';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ListingActionButtons = ({
  viewClicked,
  copyClicked,
  auditClicked,
  currRow,
  isEditable,
  isCopiable,
  isAuditable,
  sizeSM,
}) => {
  const onViewClick = () => viewClicked(currRow);
  const onCopyClick = () => copyClicked(currRow);
  const onAuditClick = () => auditClicked(currRow);

  return (
    <>
      {isEditable && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-view-button-${currRow.ListingID}`} style={{ margin: 0 }}>View Listing</Tooltip>}
        >
          <Button
            name="btnViewListing"
            type="button"
            variant="primary"
            className="mr-2"
            size={sizeSM && 'sm'}
            onClick={onViewClick}
            aria-label={`View Listing ${currRow.ListingID}`}
          >
            <i className="far fa-ellipsis-h" />
          </Button>
        </OverlayTrigger>
      )}
      {isCopiable && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-copy-button-${currRow.ListingID}`} style={{ margin: 0 }}>Copy Listing</Tooltip>}
        >
          <Button
            name="btnCopyListing"
            type="button"
            variant="primary"
            className="mr-2"
            size={sizeSM && 'sm'}
            onClick={onCopyClick}
            aria-label={`Copy Listing ${currRow.ListingID}`}
          >
            <i className="far fa-copy" />
          </Button>
        </OverlayTrigger>
      )}
      {isAuditable && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-audit-button-${currRow.ListingID}`} style={{ margin: 0 }}>Audit Listing</Tooltip>}
        >
          <Button
            name="btnAuditListing"
            type="button"
            variant="primary"
            size={sizeSM && 'sm'}
            onClick={onAuditClick}
            aria-label={`Audit Listing ${currRow.ListingID}`}
          >
            <i className="far fa-history" />
          </Button>
        </OverlayTrigger>
      )}
    </>
  );
};

ListingActionButtons.propTypes = {
  viewClicked: PropTypes.func.isRequired,
  copyClicked: PropTypes.func.isRequired,
  auditClicked: PropTypes.func.isRequired,
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
    ListingID: PropTypes.string,
  }),
  isEditable: PropTypes.bool.isRequired,
  isCopiable: PropTypes.bool.isRequired,
  isAuditable: PropTypes.bool.isRequired,
  sizeSM: PropTypes.bool.isRequired,
};

export default ListingActionButtons;
